export default {
  initial: 0,
  loading: 1,
  present: 2,
  changed: 3,
  storing: 4,
  failure: 5,
}
